import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@common-fe/common-fe';
import { ThemeWrapper as CommonThemeWrapper } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import './styles/font-families';

import App, { ThemeWrapper } from './modules/core/components';
import { FeatureFlagProvider } from './modules/featureFlags';
import MaintenanceWrapper from './modules/user/MaintenanceWrapper';
import { initDataDog } from './utils/config';
import MobileResponsiveWrapper from './MobileResponsiveWrapper';
import ScrollToTop from './ScrollToTop';

import './styles/global.scss';
// import '@common-fe/common-fe/dist/common-fe.css';
dayjs.extend(relativeTime);
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
// @ts-ignore
window.global ||= window;
initDataDog();

const REACT_APP_DOMAIN_PREFIX =
  // @ts-ignore
  window.REACT_APP_DOMAIN_PREFIX || import.meta.env.REACT_APP_DOMAIN_PREFIX || undefined;
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* @ts-ignore */}
    <BrowserRouter basename={REACT_APP_DOMAIN_PREFIX}>
      <CommonThemeWrapper>
        <ThemeWrapper>
          <MobileResponsiveWrapper>
            <QueryClientProvider client={queryClient}>
              <FeatureFlagProvider>
                <ScrollToTop />
                <MaintenanceWrapper>
                  <App />
                </MaintenanceWrapper>
              </FeatureFlagProvider>
            </QueryClientProvider>
          </MobileResponsiveWrapper>
        </ThemeWrapper>
      </CommonThemeWrapper>
    </BrowserRouter>
  </React.StrictMode>
);
